import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Button from "components/CustomButtons/Button.js";

import { FileContainer, ImageWrapper } from "./styles";

export default function FileUpload({
  text,
  addButtonProps,
  changeButtonProps,
  removeButtonProps,
  file,
  imagePreviewUrl,
  fileInput,
  onImageChange = () => {},
  onClick = () => {},
  onRemove = () => {},
}) {
  return (
    <div className="fileinput text-center">
      <FileContainer>
        <input
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onChange={onImageChange}
          ref={fileInput}
        />
        <ImageWrapper>
          <img src={imagePreviewUrl} alt="..." />
        </ImageWrapper>
        <span>{file ? file.name : ""}</span>
      </FileContainer>
      <div>
        {file === null ? (
          <Button color="info" {...addButtonProps} onClick={() => onClick()}>
            {text}
          </Button>
        ) : (
          <span>
            <Button
              color="info"
              {...changeButtonProps}
              onClick={() => onClick()}
            >
              Cambiar
            </Button>

            <Button
              color="danger"
              {...removeButtonProps}
              onClick={() => onRemove()}
            >
              <i className="fas fa-times" /> Remover
            </Button>
          </span>
        )}
      </div>
    </div>
  );
}

FileUpload.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
